import { z } from "zod";

/**
 * Geographic coordinate. Latitude in [-90, 90], longitude in [-180, 180].
 * Decimal degrees. Precision to 7 places is overkill for visual radar but
 * cheap and aids legibility when scenarios are hand-edited.
 */
export const LatLon = z.object({
  lat: z.number().gte(-90).lte(90),
  lon: z.number().gte(-180).lte(180),
});
export type LatLon = z.infer<typeof LatLon>;

/**
 * Compass bearing in degrees true. Stored normalised to [0, 360).
 */
export const BearingDeg = z.number().gte(0).lt(360);
export type BearingDeg = z.infer<typeof BearingDeg>;

export const SpeedKnots = z.number().gte(0).lte(60);
export type SpeedKnots = z.infer<typeof SpeedKnots>;

export const BoundingBox = z.object({
  nw: LatLon,
  se: LatLon,
});
export type BoundingBox = z.infer<typeof BoundingBox>;
